"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEMA = exports.MNEMONIC = exports.Position = void 0;
const json_crdt_patch_1 = require("../../json-crdt-patch");
const constants_1 = require("../constants");
var Position;
(function (Position) {
    /**
     * Specifies the absolute start of the text, i.e. the position before the
     * first character. In model space it is defined as string ID and "after"
     * anchor.
     */
    Position[Position["AbsStart"] = -1] = "AbsStart";
    /**
     * Specifies the absolute end of the text, i.e. the position after the last
     * character. In model space it is defined as string ID and "before" anchor.
     */
    Position[Position["AbsEnd"] = 9007199254740991] = "AbsEnd";
})(Position || (exports.Position = Position = {}));
exports.MNEMONIC = constants_1.ExtensionName[constants_1.ExtensionId.peritext];
const SCHEMA = (text) => json_crdt_patch_1.s.vec(json_crdt_patch_1.s.str(text), json_crdt_patch_1.s.arr([]));
exports.SCHEMA = SCHEMA;
